import { useEffect, useState } from 'react';
import { UseCopyToClipboardResponse } from '../types';
import { autoHideDuration } from '../constants';

const useCopyToClipboard = (): UseCopyToClipboardResponse => {
  const [isCopied, setIsCopied] = useState(false);
  const [values, setValues] = useState({ name: '', text: '' });

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false);
      }, autoHideDuration);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isCopied]);

  const copyToClipboard = (name: string, text: string) => {
    setValues({ name, text });
    navigator.clipboard
      .writeText(text)
      .then(() => setIsCopied(true))
      .catch(() => setIsCopied(false));
  };

  return { isCopied, values, copyToClipboard };
};

export default useCopyToClipboard;
